module.exports = __webpack_public_path__ + "img/launching_logo.5015183b.png";